export default function () {
  const swiper=new Swiper('.js-home-slider', {
    autoHeight: true,
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="'+className+'">'+(index+1)+"</span>";
      },
    },
    breakpoints: {
      1024: {
        autoHeight: false,
      },
    },
  });
}